import { API_V4 } from "@/services/config/auth-axios";

class KycService {
  verificationInternationalCard(data, onUploadProgress) {
    const { front, back } = data;
    const form = new FormData();
    form.append("front", front);
    form.append("back", back);

    return API_V4.post("/verification/id-card", form, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
  }
  uploadKycVideo(data, onUploadProgress) {
    const form = new FormData();
    form.append("video", data);
    return API_V4.post("/verification/video", form, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
  }
}

export default new KycService();
